import { acpHandoffStates } from './states';

export default (appModule) => {
  appModule.config(acpHandoffStates);
};
